import React from "react";
import { Grid } from "Components/Base/Layout";
import DateFilter from "Components/Fragment/DataDisplay/DateFilter";
import { STYLE_DATE_FILTER } from "../../styles";
import { formatDateLabel } from "../../utils/dateFilterUtils";

const DateFilters = ({
  languageContext,
  startDate,
  endDate,
  onChange,
  isMobile,
}) => (
  <>
    <Grid item xs={12}>
      <DateFilter
        label={formatDateLabel(languageContext, "after", "startDate")}
        value={startDate}
        onChange={onChange}
        name="startDate"
        sx={isMobile ? { marginBottom: 1 } : STYLE_DATE_FILTER}
      />
    </Grid>
    <Grid className="filter-grid-item" item xs={12}>
      <DateFilter
        label={formatDateLabel(languageContext, "before", "endDate")}
        value={endDate}
        onChange={onChange}
        name="endDate"
        sx={isMobile ? { marginBottom: 1 } : STYLE_DATE_FILTER}
      />
    </Grid>
  </>
);

export default DateFilters;
